export const Cookie = {
  get: (name: string) => {
    const docCookie = document?.cookie
    if (docCookie !== undefined && docCookie.match) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const c = docCookie.match(`(?:(?:^|.*; *)${name} *= *([^;]*).*$)|^.*$`)[1]
      if (c) return decodeURIComponent(c)
    }
  },
  set: (name: string, value: string, opts: any = {}) => {
    /* If options contains days then we're configuring max-age */
    if (opts.days) {
      opts['max-age'] = opts.days * 60 * 60 * 24

      /* Deleting days from options to pass remaining opts to cookie settings */
      delete opts.days
    }
    let optsStrSuffix = ''

    if (opts.Secure !== undefined) {
      if (opts.Secure === true) {
        optsStrSuffix += ' Secure;'
      }
      delete opts.Secure
    }

    if (opts.SameSite) {
      optsStrSuffix += ` SameSite=${opts.SameSite};`
      delete opts.SameSite
    }

    /* Configuring options to cookie standard by reducing each property */
    let optsStr = Object.entries(opts).reduce(
      (accumulatedStr, [k, v]) => `${accumulatedStr}; ${k}=${v}`, ''
    )

    if (optsStrSuffix) optsStr = optsStr + ';' + optsStrSuffix
    // opts += ' SameSite=Strict; Secure; HttpOnly;'

    /* Finally, creating the key */
    document.cookie = name + '=' + encodeURIComponent(value) + optsStr
  },
  delete: (name: string, opts: any) => Cookie.set(name, '', { 'max-age': -1, ...opts })
}
